export default function isVisibleNode(e) {
  return !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length));
}
